export default __webpack_public_path__ + "76c324f22f215c9956eeefdcdc50a22e.jpg";